/* eslint-disable no-unused-vars */
import React, { useState, useEffect } from "react";
import { useNavigate, useLocation } from "react-router-dom";
import { Menu, Tooltip } from "antd";
import { sideMenuList } from "../../../config/sideMenuList";
import constants from "../../../constants/constants";

import "./style.scss";

const { ROLES } = constants;
const { ROLE_MD } = ROLES;

function getItem(label, key, icon, children, type) {
  return {
    key,
    icon,
    children,
    label,
    type,
  };
}

const SideMenuItems = (visibleDrawer) => {
  const history = useLocation();
  const navigate = useNavigate();
  const [collapsed, setCollapsed] = useState(false);
  const [accountDetails, setAccountDetails] = useState();
  const [open, setOpen] = useState(false);
  const [activeKey, setActiveKey] = useState(["1"]);

  const [badgeInteractions, setBadgeInteractions] = useState({});

  useEffect(() => {
    try {
      const stored = localStorage.getItem("userinfo");
      if (stored && stored !== "undefined") {
        setAccountDetails(JSON.parse(stored));
      }

      const interactions = localStorage.getItem("new_badge_interactions");
      if (interactions) {
        setBadgeInteractions(JSON.parse(interactions));
      }
    } catch (e) {
      console.error("Error parsing userinfo or badge interactions", e);
    }
  }, []);

  const isBadgeVisible = (item) => {
    if (!item.isNew) return false;

    // Check expiry (30 days)
    if (item.releaseDate) {
      const releaseDate = new Date(item.releaseDate);
      const today = new Date();
      const differenceInTime = today.getTime() - releaseDate.getTime();
      const differenceInDays = differenceInTime / (1000 * 3600 * 24);
      if (differenceInDays > 30) return false;
    }

    // Check click limit (10 clicks)
    const count = badgeInteractions[item.id] || 0;
    if (count >= 10) return false;

    return true;
  };

  const onClickHandle = (title, route, active, directReRoute, openInNewTab, id, isNew) => {
    // Track click for "New" items
    if (isNew && id) {
      const currentInteractions = JSON.parse(localStorage.getItem("new_badge_interactions") || "{}");
      const newCount = (currentInteractions[id] || 0) + 1;
      currentInteractions[id] = newCount;
      localStorage.setItem("new_badge_interactions", JSON.stringify(currentInteractions));
      setBadgeInteractions(currentInteractions);
    }

    let finalRoute = route;
    if (id === "ticket-support" && accountDetails) {
      console.log("accountDetails>>>>>", accountDetails);

      const token = accountDetails.accessToken || "";
      const email = accountDetails.username || "";
      //userid and premiseid
      const userId = accountDetails.userId || "";
      const premiseId = accountDetails.premiseId || "";
      finalRoute = `${route}&token=${token}&email=${email}&userId=${userId}&premiseId=${premiseId}`;
    }

    if (title === " Retail Booking") {
      localStorage.removeItem("details");
      setOpen(false);
    }

    if (openInNewTab) {
      window.open(finalRoute, "_blank");
      return;
    }
    if (directReRoute) {
      window.location.href = finalRoute;

      return;
    }
    if (finalRoute) {
      // Handle dynamic route for Home menu item based on user role
      let navRoute = finalRoute;
      if (title === "Home" && accountDetails?.roles?.includes(ROLE_MD)) {
        navRoute = "/director-dashboardNew2";
      }
      setActiveKey([active]);
      navigate(navRoute);
    }
  };

  let items = [];
  sideMenuList.map((item, index) => {
    if (
      item.role === "" ||
      item.role.some((e) => accountDetails?.roles?.includes(e))
    ) {
      items.push(
        getItem(
          <div className="menu-item-wrapper">
            {item.title}

          </div>,
          item.active,
          activeKey[0] !== item.active ? (
            <Tooltip placement="rightTop" title={item.title}>
              <div className="icon-wrapper">
                <item.icon
                  className={item.iconSize === "large" ? "hub-overview-icon" : ""}
                  style={item.iconSize === "large" ? { fontSize: "24px" } : {}}
                  onClick={() =>
                    onClickHandle(
                      item.title,
                      item.route,
                      item.active,
                      item.directReRoute,
                      item.openInNewTab,
                      item.id,
                      item.isNew
                    )
                  }
                />
                {isBadgeVisible(item) && <span className="new-badge-icon">New</span>}
              </div>
            </Tooltip>
          ) : (
            <Tooltip placement="rightTop" title={item.title}>
              <div className="icon-wrapper">
                <item.fillIcon
                  className={item.iconSize === "large" ? "hub-overview-icon" : ""}
                  style={item.iconSize === "large" ? { fontSize: "24px" } : {}}

                  onClick={() =>
                    onClickHandle(
                      item.title,
                      item.route,
                      item.active,
                      item.directReRoute,
                      item.openInNewTab,
                      item.id,
                      item.isNew
                    )
                  }
                />
                {isBadgeVisible(item) && <span className="new-badge-icon">New</span>}
              </div>
            </Tooltip>
          ),
          item?.children?.map((data) =>
            getItem(
              data?.title,
              data?.active,
              <Tooltip placement="rightTop" title={item.title}>
                <item.icon
                  onClick={() =>
                    onClickHandle(
                      data.title,
                      data.route,
                      data.active,
                      data.directReRoute,
                      undefined,
                      data.id
                    )
                  }
                />
              </Tooltip>
            )
          )
        )
      );
    }
  });

  const handleClick = (e) => {
    let routeData = sideMenuList.find((it) => it.active === e.key);
    let route = routeData?.route;

    if (routeData?.id === "ticket-support" && accountDetails) {
      const token = accountDetails.accessToken || "";
      const email = accountDetails.username || "";
      route = `${route}&token=${token}&email=${email}`;
    }

    if (routeData?.openInNewTab) {
      window.open(route, "_blank");
      return;
    }
    if (routeData?.directReRoute) {
      window.open(route);
      return;
    }
    if (route) {
      // Handle dynamic route for Home menu item based on user role
      let finalRoute = route;
      if (routeData?.title === "Home" && accountDetails?.roles?.includes(ROLE_MD)) {
        finalRoute = "/director-dashboardNew2";
      }
      navigate(finalRoute);
      setActiveKey([e.key]);
    }
  };

  useEffect(() => {
    let key = sideMenuList.find((it) => it.route === history.pathname)?.active;
    if (key !== undefined) {
      localStorage.setItem("side_active", key);
      setActiveKey([key]);
    } else {
      let newKey = localStorage.getItem("side_active");
      setActiveKey([newKey]);
    }
  }, [history]);

  return (
    <div>
      <Menu
        defaultSelectedKeys={activeKey}
        selectedKeys={activeKey}
        defaultOpenKeys={["sub1"]}
        mode="inline"
        theme="light"
        collapsed={collapsed?.toString()}
        // inlineCollapsed={collapsed}
        onClick={handleClick}
        items={items}
      ></Menu>
    </div>
  );
};

export default SideMenuItems;
